import { autobind } from "macguffin"
import { Text, Sprite } from 'pixi.js'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import Symbol from "./Symbol"

const BADGE_OFFSET = {
    x: 0.15,
    y: 0.15
}

const BADGE_SCALE = 0.75

const TEXT_FORMAT = {
    fontFamily: "WorkSans-Bold",
    fontSize: 48,
    fill: 0xffffff,
    align: "center",
    strokeThickness: 4,
    stroke: 'black',
    miterLimit: 2,
    padding: 10
}

const PLUS_ONE = "+1"

export default class ScatterSymbol extends Symbol {
    constructor(symbolInfo, addCount) {
        super(symbolInfo)

        if (addCount) {
            this.setupBadge()
        }
    }

    setup() {
        const { symbolInfo } = this
        const texture = this.getNormalSymbolTexture(symbolInfo)
        this.sprite = new Sprite(texture)
        this.addChild(this.sprite)
        this.key = "SC"
    }

    setupBadge() {
        const texture = resources["badge"].texture
        const badge = this.badge = new Sprite(texture)
        badge.x = 0
        badge.y = 0

        const text = new Text(PLUS_ONE, TEXT_FORMAT)
        text.anchor.set(0.5)
        text.x = badge.width * 0.5
        text.y = badge.height * 0.5
        badge.addChild(text)

        this.addChild(badge)
    }

    updateSprite = (size) => {
        const { sprite, badge } = this
        const { width, height } = size

        super.updateSprite(size)

        if (badge) {
            badge.scale.x = sprite.scale.x * BADGE_SCALE
            badge.scale.y = sprite.scale.y * BADGE_SCALE
            badge.x = width * BADGE_OFFSET.x
            badge.y = height * BADGE_OFFSET.y
        }
    }

}
